(() => {
  const WRAPPER = '.ysf-reviews-mini';
  const WIDGET =
    '.gw-rv-mini-slider-widget, .gw-rv-product-mini-slider-widget';

  let syncing = false;
  let scheduled = null;

  const contentHasReviews = (widget) => {
    const text = (widget.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length > 0) return true;
    return widget.querySelector('img, svg, button, a, li') != null;
  };

  const setHidden = (el, hidden) => {
    if (!el) return;
    const isReady = el.classList.contains('ysf-reviews-mini--ready');
    const isEmpty = el.classList.contains('ysf-reviews-mini--empty');
    if (!hidden && isReady && !isEmpty) return;
    if (hidden && !isReady && isEmpty) return;

    if (hidden) {
      el.classList.remove('ysf-reviews-mini--ready');
      el.classList.add('ysf-reviews-mini--empty');
      el.style.setProperty('display', 'none', 'important');
    } else {
      el.classList.add('ysf-reviews-mini--ready');
      el.classList.remove('ysf-reviews-mini--empty');
      el.style.removeProperty('display');
    }
  };

  const syncWidget = (widget) => {
    const empty = !contentHasReviews(widget);
    setHidden(widget, empty);
    setHidden(widget.closest('.reviews-general-theme'), empty);
    setHidden(widget.closest(WRAPPER), empty);
  };

  const syncAll = () => {
    if (syncing) return;
    syncing = true;
    try {
      document.querySelectorAll(WIDGET).forEach(syncWidget);
      document.querySelectorAll(WRAPPER).forEach((block) => {
        if (!block.querySelector(WIDGET)) setHidden(block, true);
      });
    } finally {
      syncing = false;
    }
  };

  const scheduleSync = () => {
    if (syncing || scheduled) return;
    scheduled = requestAnimationFrame(() => {
      scheduled = null;
      syncAll();
    });
  };

  const observe = () => {
    document.querySelectorAll(`${WRAPPER}, .reviews-general-theme`).forEach((root) => {
      if (root.dataset.ysfReviewsObserved === '1') return;
      root.dataset.ysfReviewsObserved = '1';
      new MutationObserver(() => {
        if (!syncing) scheduleSync();
      }).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: false,
      });
    });
  };

  const init = () => {
    observe();
    syncAll();
    [300, 1000, 2500].forEach((ms) => setTimeout(syncAll, ms));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
